/**
 * What `::files` renders: the answer's closing files section (ADR-22 decision 3, ADR-23 layer 2).
 *
 * The model used to be asked to write this section itself — a rule, a heading and one link per
 * bullet — which made a presentation decision part of the answer's prose, and every element of
 * it something the model could forget or vary. One directive says "the files go here" and the
 * portal owns what that looks like, so the section is identical in every answer and a file
 * cannot be omitted from it by a slip of the pen.
 *
 * A turn that produced nothing renders nothing: an empty heading over an empty grid would be a
 * worse answer than no section at all, and the model cannot always know at writing time.
 */

import { Text } from '@mantine/core';
import { typo } from '../typography.css';
import { ArtifactCard } from './ArtifactCard';
import { artifactCard } from './ArtifactCard.css';
import { useTurnFiles } from './TurnFiles';

export function FilesSummary() {
  const files = useTurnFiles();

  if (files.length === 0) return null;

  return (
    <>
      <hr className={typo.md.hr} />
      {/* `h2` is the level an answer's own sections use, so the files section sits alongside
          them rather than under the last one. */}
      <Text component="h2" className={typo.md.h2}>
        Files
      </Text>
      <Text component="ul" className={artifactCard.list}>
        {files.map((file) => (
          <Text component="li" key={file.artifactId} className={artifactCard.listItem}>
            {/* No label: the card names the file from the transcript's own lineage, which is
                the one name that is right whatever the prose called it. */}
            <ArtifactCard artifactId={file.artifactId} label="" />
          </Text>
        ))}
      </Text>
    </>
  );
}
